import { UserType } from "../../services/medicationmanagement/medsUser/MedsUserApi";
import { ResidentHeader } from "../resident-header/ResidentHeader";
import { ResidentTopBar } from "../resident-header/ResidentTopBar";
import { Grid } from "@material-ui/core";
import { ExternalLookupIdentifier } from "@communicare/medications/Shared/SharedModels";
import { Patient } from "../../services/medicationmanagement/patientApi/models/Patient";
import { PatientAllergyInfo } from "../../services/medicationmanagement/patientApi/models/PatientAllergyInfo";
import styles from '../resident-medications/ResidentMedications.module.scss';
import {IndividualHealthcareIdentifier} from "../../services/healthcareidentifier/models/IndividualHealthcareIdentifier"
import { PharmacyMedicationsDetails } from "./PharmacyMedicationsDetails";
import { useHistory, useRouteMatch } from "react-router";

export interface IResidentMedicationsProps {
  resident: Patient;
  encounter: ExternalLookupIdentifier;
  allergyInfo: PatientAllergyInfo;
  ihi: IndividualHealthcareIdentifier;
  createPharmacyRequest: () => void;
  loadChartContactDetails: () => void;
}

export const PharmacyMedications = (props: IResidentMedicationsProps) => {
  return (
    <Grid container spacing={0} direction={"column"} className={styles.root}>
      <ResidentTopBar resident={props.resident} encounter={props.encounter} ihi={props.ihi} userType={UserType.Pharmacist}/>
      <Grid item>
        <ResidentHeader patientInfo={props.resident} allergyInfo={props.allergyInfo} userType={UserType.Pharmacist} ihi={props.ihi} loadChartContactDetails={props.loadChartContactDetails}/>
      </Grid>

      <Grid item>
      <PharmacyMedicationsDetails residentAuthoringSystem={props.resident.authoringSystem||''} residentAuthoringSystemForeignKey={props.resident.authoringSystemForeignKey||''}  />
      </Grid>
    </Grid>
  );
};
